export const GET_HISTORIC_DATA = "GET_HISTORIC_DATA";
export const GET_MARKET_CAP = "GET_MARKET_CAP";
export const GET_SEARCH_TICKER = "GET_SEARCH_TICKER";
export const GET_FAVOURITES = "GET_FAVOURITES";
export const GET_BONDS = "GET_BONDS";

